import { getCsrfValue } from "../../api/ApiHelper";
import { resolveApiUrl } from "../../utils/url/urlResolver";
import { type UserAccountValues } from "~/UserAccounts/userAccountTypes";

export async function actionsUserAccount(
  data: UserAccountValues,
  isEdit: boolean,
  isCreate: boolean,
  uid: string,
): Promise<string[]> {
  const user = `?user=${data.email}`;
  let url;
  if (isEdit) {
    url = "/my-company/organization-management/manage-users/edit" + user;
  } else if (isCreate) {
    url = "/my-company/organization-management/manage-users/create" + user;
  } else {
    url = "/my-company/organization-management/manage-users/delete" + user;
  }

  const apiUrl = resolveApiUrl(url);
  const isDelete = !(isEdit || isCreate);
  const commonData = {
    active: data.status === "true",
    role: data.role,
    uid: uid,
    email: data.email,
    firstName: data.firstName,
    lastName: data.lastName,
    jobTitle: data.jobTitle,
    functionalArea: data.functionalArea,
    phone: data.phone,
    salutationCode: data.salutation,
    titleCode: data.title,
    lmsRequest: data.lmsRequest,
    accountCodes: data.accountCodes.toString(),
    endCustomerCodes: data.endCustomerCodes.toString(),
  };
  const bodyData = !data.lmsRequest
    ? {
        ...commonData,
      }
    : {
        ...commonData,
        customerCategoryCode: data.customerCategoryCode,
        knowledgeAreaCode: data.knowledgeAreaCode,
        languageIsoCode: data.languageIsoCode,
        vatNumber: data.vatNumber,
      };

  const response = await fetch(apiUrl, {
    body: isDelete ? undefined : JSON.stringify(bodyData),
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    method: isDelete ? "GET" : "POST",
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  });
  if (!response.ok) {
    const data = (await response.json()) as { error: string };
    return [data.error];
  } else {
    return [];
  }
}
